
































































































































































































































































































































































































































































import { Component, Vue, PropSync, Watch } from "vue-property-decorator";
import Loading from "@/components/loading/Loading.vue";
import * as farmsService from "@/services/farms";
import {
  FarmListRow,
  FarmListFilter,
  MonitoringCell,
  AnalysesCell,
} from "@/api/farms/types";
import AgroResponsiveTable from "@/components/agroResponsiveTable/AgroResponsiveTable.vue";
import { stringNotEmpty } from "@/filters/string";
import { formattedAreaInHa } from "@/filters/area";
import AgroTablePagination from "@/components/agroTablePagination/AgroTablePagination.vue";
import AgroGenericModal from "@/components/agroGenericModal/AgroGenericModal.vue";
import { Page } from "@/api/types";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import { fi, fil } from "date-fns/locale";
import ConfirmationModal from "@/components/confirmationModal/ConfirmationModal.vue";
import AnalysesBadge from "./components/analyses/AnalysesBadge.vue";
import { monitoring } from "@/store/monitoring";
import FarmDrawing from "./components/farm-drawing/FarmDrawingController.vue";
import AnalysisModalController from "@/components/analysisModal/AnalysisModalController.vue";
import { Farm } from "@/api/farms/types";
import * as farmsApi from "@/api/farms";
import CardAnalysesCountController from "./components/card-analyses-count-controller/CardAnalysesCountController.vue";
import CardFarmsAreaController from "./components/card-farms-area-controller/CardFarmsAreaController.vue";
import CardFarmsCountController from "./components/card-farms-count-controller/CardFarmsCountController.vue";
import CardAnalysesMonitoringCount from "./components/card-analyses-monitoring-count/CardAnalysesMonitoringCount.vue";
import AgroOnOff from "@/components/agroOnOff/AgroOnOff.vue";
import CardProcessingCountController from "./components/card-processing-count-controller/CardProcessingCountController.vue";
import ModalAnalysesStatus from "./components/modal-analyses-status/ModalAnalysesStatus.vue";
import FarmsMap from "./components/farms-map/FarmsMapController.vue";
import Tabs from "./components/tabs/TabsController.vue";
import EventBus from "@/event-bus";
import ModalUploadFarm from "./components/bulk/modal-upload-farm/ModalUploadFarm.vue";
import BulkUploaderValidator from './components/bulk/bulk-uploader-validator/BulkUploaderValidator.vue';

const getAnalysesRoute = (route: string) => (uuid: string) => {
  return {
    name: route,
    params: { uuid, source: "farms-home" },
  };
};

@Component({
  name: "FarmsHome",
  components: {
    Loading,
    AgTable: AgroResponsiveTable,
    AgPagination: AgroTablePagination,
    AgroIcons,
    AnalysesBadge,
    AgroGenericModal,
    ConfirmationModal,
    FarmDrawing,
    AnalysisModalController,
    CardAnalysesCount: CardAnalysesCountController,
    cardFarmsArea: CardFarmsAreaController,
    cardFarmsCount: CardFarmsCountController,
    CardAnalysesMonitoring: CardAnalysesMonitoringCount,
    AgroOnOff,
    cardProcessing: CardProcessingCountController,
    ModalAnalysesStatus,
    FarmsMap,
    FarmsHomeTabs: Tabs,
    ModalUploadFarm,
    BulkUploaderValidator,
  },
  filters: {
    stringNotEmpty,
    formattedAreaInHa,
  },
})
export default class Farms extends Vue {
  private readonly tableColumns = [
    { name: "farm-name", sortable: true },
    { name: "owner-name", sortable: true },
    { name: "area", sortable: true },
    { name: "city", sortable: true },
    { name: "state-acronym", sortable: true },
    { name: "monitoring", sortable: false },
    { name: "analyses", sortable: false },
    { name: "actions", sortable: false },
  ];
  
  private get fields() {
    return this.tableColumns.map(
      v => ({
        label: this.$t(`farms-home.${v.name}`),
        key: v.name,
        sortable: v.sortable,
      })
    );
  }

  private readonly columnLabels = {
    nameWithCode: "farm-name",
    ownerName: "owner-name",
    area: "area",
    city: "city-name",
    stateAcronym: "state-acronym",
    monitoring: "monitoring",
    analyses: "analyses",
    actions: "actions",
  };

  private pageSize = 20;
  private totalPages = 0;
  private totalElements = 0;
  private currentPage = 0;

  private analiticaLocationFor = getAnalysesRoute("analyses");
  private sentinelaLocationFor = getAnalysesRoute("monitoring");

  private filter: FarmListFilter = {
    maxArea: null,
    minArea: null,
    onlyUserFarms: false,
    onlyActiveMonitoring: false,
    showFilters: true,
    showCards: true,
    lngLat: "",
    territoryCode: ""
  };
  private searchTimer: any;
  private isDeleteFarmConfirmationOpen: boolean = false;
  private farmToDelete: FarmListRow | null = null;

  private createFarmState = "closed";

  private farmTo: Farm | null = null;
  private farmForAnalysis: Farm | null = null;

  private analysisTypeTo: string | null = null;

  private analysisModal: boolean = false;

  private isModalAnalysesStatusVisible: boolean = false;

  private isModalUploadFarmVisible: boolean = false;
  private isModalBulkValidationVisible: boolean = false;

  private isAddNewFarm: boolean = false;
  private isRemovedFarm: boolean = false;

  @Watch("createFarmState", { immediate: true })
  private onChangeFarmlist (val: string, oldVal: string) {
    val === 'closed' ? this.isAddNewFarm = true : this.isAddNewFarm = false;
  }

  private sorted(event: any) {
    this.filter.directionParam = event["dir"];

    switch (event["key"]) {
      case "farm-name":
        this.filter.field = "name";
        break;
      case "owner-name":
        this.filter.field = "owner.name";
        break;
      case "area":
        this.filter.field = "area";
        break;
      case "city":
        this.filter.field = "cityName";
        break;
      case "state-acronym":
        this.filter.field = "stateAcronym";
        break;
    }

    this.paginateTimeOut(true);
  }

  private created() {
    const filter = this.$store.state.farms.farmListFilter;
    if (filter) {
      this.filter = filter;
    }

    EventBus.$on("analysis:create", this.requestCreateAnalysis);
  }

  private async mounted() {
    await farmsService.clearFarmList();
  }

  private setShowFilters(action: boolean) {
    this.filter.showFilters = action;
  }

  private setShowCards(action: boolean) {
    this.filter.showCards = action;
  }

  private get isLoading(): boolean {
    const loadingConditions = [
      this.$store.getters[`farms/isFetchingFarmList`],
      this.createFarmState === "creating:farm",
    ];
    return loadingConditions.some((condition) => condition);
  }

  private get farmList(): FarmListRow[] {
    return this.$store.state.farms.farmListContext;
  }

  private clearFilter() {
    this.filter = {
      maxArea: null,
      minArea: null,
      onlyUserFarms: false,
      onlyActiveMonitoring: false,
      showFilters: true,
      showCards: true
    };
    this.currentPage = 0;

    farmsService.clearFarms();
    this.onPaginate(new Page(this.currentPage, this.pageSize), true);
  }

  private async onPaginate(page: Page, immediate: boolean): Promise<void> {
    const paginated = await farmsService.getFarmsList(page, this.filter);

    this.pageSize = paginated.size;
    this.totalPages = paginated.totalPages;
    this.totalElements = paginated.totalElements;
    this.currentPage = paginated.page;
    farmsService.setFilter(this.filter);
  }

  private getLastYear(years: number[]) {
    if (years.length === 0) return null;
    return Math.max.apply(undefined, years);
  }

  private getAnalysesYears(analysis: MonitoringCell | AnalysesCell) {
    if (analysis instanceof MonitoringCell) {
      return this.$t("farms-home.monitoring-year", {
        year: analysis.monitoringYear,
      });
    } else if (analysis instanceof AnalysesCell) {
      const sortedYears = analysis.years.flat().sort((a, b) => a - b);
      return this.$t("farms-home.analyses-years", {
        years: `${sortedYears.join(", ")}`,
      });
    }
  }

  private paginateTimeOut(immediate: boolean = false) {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    }
    this.searchTimer = setTimeout(
      () => {
        this.currentPage = 0;
        this.onPaginate(new Page(this.currentPage, this.pageSize), true);
      },
      immediate ? 0 : 800
    );
  }

  private openDeleteFarmModal(farm: FarmListRow) {
    this.farmToDelete = farm;
    this.isDeleteFarmConfirmationOpen = true;
  }

  private async confirmRemoveFarm() {
    this.isRemovedFarm = false;
    try {
      await farmsService.deleteFarm(this.farmToDelete!.uuid);
    } finally {
      this.cancelRemoveFarm();
      this.onPaginate(new Page(this.currentPage, this.pageSize), true);
      this.isRemovedFarm = true;
    }
  }

  private cancelRemoveFarm() {
    this.farmToDelete = null;
    this.isDeleteFarmConfirmationOpen = false;
  }

  private createFarm() {
    this.createFarmState = "initial";
  }

  private uploadFarms() {
    this.isModalUploadFarmVisible = true;
  }
  private cancelUploadFarms() {
    this.isModalUploadFarmVisible = false;
  }

  private getAnalysisType(analysisType: string) {
    this.analysisTypeTo = analysisType;
  }

  private closeCreateAnalysis() {
    this.analysisModal = false;
    this.farmTo = null;
    this.paginateTimeOut(true);
  }

  private requestCreateAnalysis(payload: {
    farm: FarmListRow;
    analysisType: string;
  }) {
    this.openCreateAnalysis(payload.farm, payload.analysisType);
  }

  private openCreateAnalysis(farmListRow: FarmListRow, analysisType: string) {
    this.getFarmByUuid(farmListRow.uuid, analysisType);
  }

  private async getFarmByUuid(uuid: string, analysisType: string) {
    try {
      const response = (await farmsApi.getFarmByUuid(uuid)).data;
      this.farmForAnalysis = response;
      this.analysisTypeTo = analysisType;
      this.analysisModal = true;
    } catch {
      this.analysisTypeTo = "";
    }
  }

  private convertFarmListRowToFarm(farmListRow: FarmListRow) {
    const farm = farmListRow as unknown as Farm;
    return farm;
  }

  private toggleModalStatus() {
    this.isModalAnalysesStatusVisible = !this.isModalAnalysesStatusVisible;
  }

  private closeModalStatus() {
    this.isModalAnalysesStatusVisible = false;
  }
}
